export function facilitatorsSlider() {
    let $facilitators = $('.facilitators');

    $facilitators.find(".slider").slick({
        dots: false,
        infinite: $facilitators.hasClass('event-lp') ? true : false,
        speed: 300,
        autoplay: $facilitators.hasClass('event-lp') ? true : false,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: $(".facilitators .common-slider-controls .prev-arrow"),
        nextArrow: $(".facilitators .common-slider-controls .next-arrow"),
        responsive: [
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1800,
                settings: {
                    slidesToShow: 4,
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/facilitators-slider.js